import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerDashboard } from '@vision/ui/interfaces';
import type {
  PlannerDashboardsArgs,
  PlannerDashboardDetailArgs,
  PlannerDashboardCreateArgs,
  PlannerDashboardUpdateArgs,
  PlannerDashboardDeleteArgs,
} from './dashboards.api.types';
import {
  buildGetDashboardsRequest,
  buildGetDashboardByIdRequest,
  buildCreateDashboardRequest,
  buildUpdateDashboardRequest,
  buildDeleteDashboardRequest,
} from './dashboards.routes';

export const PlannerDashboardEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboards: builder.query<PlannerDashboard[], PlannerDashboardsArgs>({
      query: buildGetDashboardsRequest,
      providesTags: (result) => [
        { type: 'Dashboard', id: 'LIST' },
        ...(result?.map(({ id }) => ({ type: 'Dashboard' as const, id })) ?? []),
      ],
    }),
    getDashboardById: builder.query<ApiResponse<PlannerDashboard>, PlannerDashboardDetailArgs>({
      query: buildGetDashboardByIdRequest,
      providesTags: (result, error, arg) => [{ type: 'Dashboard', id: arg.dashboardId }],
    }),
    createDashboard: builder.mutation<ApiResponse<PlannerDashboard>, PlannerDashboardCreateArgs>({
      query: buildCreateDashboardRequest,
      invalidatesTags: ['Planner', { type: 'Dashboard', id: 'LIST' }],
    }),
    updateDashboard: builder.mutation<PlannerDashboard, PlannerDashboardUpdateArgs>({
      query: buildUpdateDashboardRequest,
      invalidatesTags: (result, error, arg) => [
        { type: 'Dashboard', id: arg.dashboardId },
        { type: 'Dashboard', id: 'LIST' },
        'Planner',
      ],
    }),
    deleteDashboard: builder.mutation<void, PlannerDashboardDeleteArgs>({
      query: buildDeleteDashboardRequest,
      invalidatesTags: (result, error, arg) => [
        { type: 'Dashboard', id: arg.dashboardId },
        { type: 'Dashboard', id: 'LIST' },
        'Planner',
      ],
    }),
  }),
});

export const {
  useGetDashboardsQuery,
  useLazyGetDashboardByIdQuery,
  useCreateDashboardMutation,
  useUpdateDashboardMutation,
  useDeleteDashboardMutation,
} = PlannerDashboardEndpoints;
